// extracted by mini-css-extract-plugin
export default {"flex":"flex_flex__exvnr"};